import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import AssessmentIcon from "@material-ui/icons/Assessment";
import LockIcon from "@material-ui/icons/Lock";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import PersonIcon from "@material-ui/icons/Person";
import SchoolIcon from "@material-ui/icons/School";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import authApi from "api/authApi";
import { useAppDispatch, useAppSelector } from "app/hooks";
import BACK_GROUND from "assets/img/bg_login.jpg";
import BACKGROUND_MOBILE from "assets/img/bg_mobile.jpg";
import FLAG_KOREA from "assets/img/flag-ko.png";
import FLAG_VIETNAM from "assets/img/flag-vi.png";
import InputField from "components/FormFields/InputField";
import { TOKEN, TOKEN_ADMIN } from "constants/config";
import { fetchIsChecked, handleChangeLanguage, selectIsChecked } from "features/Auth/authSlice";
import { LoginSuccess, UserLogin } from "models/auth";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import useStyles from "./style";

const schema = yup.object().shape({
  username: yup.string().required("* Vui lòng nhập Email hoặc Mã nhân viên."),
  password: yup.string().required("* Vui lòng nhập Mật khẩu."),
});

export default function Login() {
  const token_user = localStorage.getItem(TOKEN);
  const token_admin = localStorage.getItem(TOKEN_ADMIN);

  const [valueLanguage, setValueLanguage] = useState(localStorage.getItem("language") || "vi");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [disabledSubmit, setDisabledSubmit] = useState(false);
  const isChecked = useAppSelector(selectIsChecked);

  const initialValues: UserLogin = {
    username: localStorage.getItem("username") || "",
    password: localStorage.getItem("password") || "",
  };

  const { control, handleSubmit } = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(schema),
  });

  const handleSubmitForm = async (infoUser: UserLogin) => {
    setDisabledSubmit(true);
    if (isChecked) {
      localStorage.setItem("username", infoUser.username);
      localStorage.setItem("password", infoUser.password);
    }
    try {
      const res: LoginSuccess = await authApi.login(infoUser);
      setDisabledSubmit(false);

      if (res.responseCode === "00") {
        localStorage.setItem(TOKEN, res.accessToken);
        if (res.role === "STUDENT") {
          localStorage.setItem("ROLE", "STUDENT");
          toast.success(`${t("auth.login.success") || "Đăng nhập thành công!"}`);
          await navigate("/home");
        } else {
          toast.success(`${t("auth.login.success") || "Đăng nhập quản trị thành công!"}`);
          localStorage.setItem("ROLE", "ADMIN");
          localStorage.setItem(TOKEN_ADMIN, res.accessToken);
          await navigate("/admin");
        }
      } else if (res.responseCode === "06") {
        toast.error(`${t("auth.login.approved") || "Tài khoản đang chờ duyệt."}`);
        throw new Error(`${t("auth.login.approved")}`);
      } else {
        toast.error(`${t("auth.login.failed") || "Đăng nhập thất bại. Kiểm tra lại tài khoản."}`);
        throw new Error(`${t("auth.login.failed")}`);
      }
    } catch (error: any) {
      setDisabledSubmit(false);
      console.log(error);
    }
  };

  const handleChangeCheckBox = () => {
    dispatch(fetchIsChecked());
  };

  const classes = useStyles({
    background: BACK_GROUND,
    bg_mobile: BACKGROUND_MOBILE,
  });

  if (token_admin) {
    return <Navigate to="/admin" />;
  }
  if (token_user) {
    return <Navigate to="/home" />;
  }

  const handleSelectLanguage = (event: React.ChangeEvent<{ value: any }>) => {
    const { value } = event.target;
    localStorage.setItem("language", value);
    dispatch(handleChangeLanguage(value));
    setValueLanguage(value);
  };

  return (
    <Box className={classes.pageRoot}>
      {/* Left Side: Hero Section */}
      <Box className={classes.heroSection}>
        <Box className={classes.heroGlow1} />
        <Box className={classes.heroGlow2} />

        <Box className={classes.heroBadge}>
          <SchoolIcon style={{ fontSize: 18 }} />
          HỆ THỐNG ĐÀO TẠO DOANH NGHIỆP GPET EDU
        </Box>

        <Box className={classes.heroContent}>
          <Typography className={classes.heroTitle}>
            Nâng Tầm Năng Lực Đội Ngũ Doanh Nghiệp
          </Typography>
          <Typography className={classes.heroSubtitle}>
            Hệ thống đào tạo trực tuyến hiện đại, hỗ trợ học tập, làm bài kiểm tra và theo dõi tiến độ học tập toàn diện cho cán bộ nhân viên GPET.
          </Typography>

          <Box className={classes.featureGrid}>
            <Box className={classes.featureCard}>
              <Box className={classes.featureIconBox}>
                <MenuBookIcon style={{ fontSize: 22 }} />
              </Box>
              <Box>
                <Typography className={classes.featureTitle}>
                  Kho Bài Học Chuẩn Hóa
                </Typography>
                <Typography className={classes.featureDesc}>
                  Truy cập các khóa học video sinh động & tài liệu chuyên môn cao.
                </Typography>
              </Box>
            </Box>

            <Box className={classes.featureCard}>
              <Box className={classes.featureIconBox}>
                <AssessmentIcon style={{ fontSize: 22 }} />
              </Box>
              <Box>
                <Typography className={classes.featureTitle}>
                  Khảo Sát & Thi Trực Tuyến
                </Typography>
                <Typography className={classes.featureDesc}>
                  Hệ thống chấm điểm tự động & báo cáo học tập tức thì.
                </Typography>
              </Box>
            </Box>

            <Box className={classes.featureCard}>
              <Box className={classes.featureIconBox}>
                <VerifiedUserIcon style={{ fontSize: 22 }} />
              </Box>
              <Box>
                <Typography className={classes.featureTitle}>
                  Bảo Mật & Chứng Nhận
                </Typography>
                <Typography className={classes.featureDesc}>
                  Theo dõi kết quả chính xác & chứng nhận hoàn thành khóa học.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Typography className={classes.heroFooter}>
          © 2026 GPET Edu. Tất cả quyền được bảo lưu.
        </Typography>
      </Box>

      {/* Right Side: Login Form */}
      <Box className={classes.formSection}>
        <Box className={classes.languageWrapper}>
          <FormControl className={classes.selectLanguage}>
            <Select
              value={valueLanguage}
              onChange={handleSelectLanguage}
              variant="outlined"
              displayEmpty
            >
              <MenuItem value="vi">
                <img src={FLAG_VIETNAM} className={classes.icon__flag} alt="Vietnamese" />
                <span>Việt Nam</span>
              </MenuItem>
              <MenuItem value="ko">
                <img src={FLAG_KOREA} className={classes.icon__flag} alt="Korean" />
                <span>Korean</span>
              </MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box className={classes.formCard}>
          <Typography className={classes.formTitle}>
            {t("auth.login.upercase") || "ĐĂNG NHẬP"}
          </Typography>
          <Typography className={classes.formSubtitle}>
            Vui lòng nhập tài khoản để tiếp tục vào hệ thống.
          </Typography>

          <form onSubmit={handleSubmit(handleSubmitForm)}>
            <Box className={classes.fieldWrapper}>
              <Typography className={classes.formLabel}>
                <PersonIcon style={{ fontSize: 18, color: "#4F46E5" }} />
                {t("auth.user") || "TÀI KHOẢN / EMAIL"}
              </Typography>
              <InputField
                name="username"
                label={t("staffId-or-email") || "Nhập Email hoặc Mã nhân viên"}
                control={control}
                autocomplete={true}
                isShowLabel={false}
              />
            </Box>

            <Box className={classes.fieldWrapper}>
              <Typography className={classes.formLabel}>
                <LockIcon style={{ fontSize: 18, color: "#4F46E5" }} />
                {t("auth.password") || "MẬT KHẨU"}
              </Typography>
              <InputField
                name="password"
                label={t("auth.password") || "Nhập mật khẩu"}
                control={control}
                inputType="password"
                isShowLabel={false}
              />
            </Box>

            <Box className={classes.optionsRow}>
              <FormControlLabel
                className={classes.checkboxRemember}
                control={
                  <Checkbox
                    checked={localStorage.getItem("isChecked") === "true" ? true : isChecked}
                    onChange={handleChangeCheckBox}
                    name="rememberMe"
                    color="primary"
                  />
                }
                label={t("auth.rememberMe") || "Ghi nhớ đăng nhập"}
              />

              <Typography
                className={classes.forgotPasswordLink}
                onClick={() => navigate("/forgot-password")}
              >
                {t("auth.forgotPassword") || "Quên mật khẩu?"}
              </Typography>
            </Box>

            <Button
              variant="contained"
              type="submit"
              disabled={disabledSubmit}
              endIcon={<ArrowForwardIcon />}
              className={classes.btnSubmit}
            >
              {t("auth.login") || "ĐĂNG NHẬP HỆ THỐNG"}
            </Button>

            <Typography className={classes.registerPrompt}>
              {t("auth.dontHaveAccount") || "Chưa có tài khoản?"}
              <span onClick={() => navigate("/register")}>
                {t("auth.register") || "Đăng ký tài khoản mới"}
              </span>
            </Typography>
          </form>
        </Box>
      </Box>
    </Box>
  );
}
